import { Textarea } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

// The longest reason the backend keeps (IGNORED_REASON_MAX_LENGTH).
const MAX_LENGTH = 500;

/**
 * Why a movement is being ignored, in the user's words (MI-315). Optional, and
 * asked the same way wherever a movement gets ignored: the panel's menu, a
 * delete that turns into an ignore, and the phone's sheet.
 */
export default function IgnoreReasonField({ value, onChange, ...props }) {
  const { t } = useTranslation('movements');
  return (
    <Textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={t('detailPanel.ignoreDialog.reasonPlaceholder')}
      aria-label={t('detailPanel.ignoreDialog.reasonLabel')}
      maxLength={MAX_LENGTH}
      rows={3}
      {...props}
    />
  );
}
